import _get from 'lodash/get';


export const getWire = state => _get(state, 'wire.data');

export const getLoadWireError = state => _get(state, 'wire.errors.loadWireError');
export const getEditWireError = state => _get(state, 'wire.errors.editWireError');
export const getCancelWireError = state => _get(state, 'wire.errors.cancelWireError');
export const getLoadWireFileError = state => _get(state, 'wire.errors.loadWireFileError');
